// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2CYbj","gfeWrapper":"CalendarEvent_gfeWrapper__1jVFI"};